// TODO: DEN-27 Get real token prices from the server instead of this mock function
export function getMockTokenPrice(symbol: string): number {
  if (symbol.includes('ETH')) return 3200;
  if (symbol.includes('USD')) return 1;
  if (symbol.includes('BTC')) return 100000;
  return 3; // Default mock price
}
